import { WhatweDoCompWrapper } from "../../styles/StyledComponents/WhatweDoCompWrapper";
import assests from "../../ui/assests";
import CommonHeading from "../CommonHeading/CommonHeading";
import { CommonOverlayBox } from "../CommonOverlayBox/CommonOverlayBox";

const WhatweDoComp = () => {
  return (
    <WhatweDoCompWrapper>
      <div className="container">
        <CommonHeading
          className="what_we_are_heading"
          isPrimary
          title="What we Do..."
          paratext="From idea to launch, we provide full-spectrum web solutions tailored to each clients unique goals."
        />
        <CommonOverlayBox
          overlayBgImg={assests.overbgImg01}
          className=""
          btnText="View All Works"
          descriptionText="We design and develop custom websites that are modern, responsive, and built to help your business grow."
        />
      </div>
    </WhatweDoCompWrapper>
  );
};

export default WhatweDoComp;
